module.exports = __webpack_public_path__ + "img/2-participated.b262998a.png";